const apiConfig = {
  index: {
    paths: {
      trend_years: '/anon/spv/index/query/trend/years/',
      trend_config: '/anon/spv/index/query/trend/config/',
      trend_details: '/anon/spv/index/query/trend/details/',
      trend_create_pdf: '/anon/spv/index/trend/pdf/',
      trend_query: '/anon/spv/index/query/day/',
      deka_years: '/anon/spv/index/deka/years/',
      deka_config: '/anon/spv/index/deka/config/',
      deka_daily: '/anon/spv/index/deka/daily/',
      deka_query: '/anon/spv/index/deka/query/',
      deka_day: '/anon/spv/index/deka/day/',
      deka_create_pdf: '/anon/spv/index/deka/pdf/',
      climate_years: '/anon/spv/index/climatic/years/',
      climate_config: '/anon/spv/index/climatic/config/',
      climate_daily: '/anon/spv/index/climatic/daily/',
      climate_query: '/anon/spv/index/climatic/query/',
      climate_day: '/anon/spv/index/climatic/day/',
      climate_create_pdf: '/anon/spv/index/climatic/pdf/',
      factsheet_download: '/anon/fact_sheet/download/',
      // general endpoints
      years: '/anon/spv/index/years/',
      daily: '/anon/spv/index/daily/',
      query: '/anon/spv/index/query/',
      day: '/anon/spv/index/day/',
      pdf: '/anon/spv/index/pdf/',
    }
  },
  info: {
    paths: {
      infodata: '/anon/info/',
    }
  }
};

export default apiConfig;



// WEBPACK FOOTER //
// ./src/api/config.js